import React from "react"
import useT from "../hooks/useT"
import LegalPage from "./LegalPage"
import en from "../legal/en/privacy-policy.md?raw"
import bg from "../legal/bg/politika-za-poveritelnost.md?raw"

const TEXTS = { en, bg }

export default function PrivacyPage() {
  const t = useT()
  return <LegalPage title={t`Privacy Policy`} texts={TEXTS} />
}
